<template>
    <div>
        <table style="width:100%" class="table-font" v-if="result!==null && Object.keys(result).length!==0">        

            <!-- row 0 table headers -->

            <tr class="tr-bottom-border">
                <th class="td-left bold" :colspan="lg?2:1">{{ this.title }}</th>
                <th class="td-right" v-if="!xs">Turnover YTD {{ this.previousYear.year }}</th>
                <th class="td-right" v-if="!xs">Turnover YTD {{ this.thisYear.year }}</th>
                <th></th>
                <th v-if="!xs"></th>
                <th class="td-right" v-if="!xs">{{ this.bookings }} {{ this.previousYear.year }}</th>
                <th class="td-right">{{ this.bookings }} {{ this.thisYear.year }}</th>
                <th v-if="!xs"></th>
                <th class="td-right" v-if="!xs">{{ this.valuebookings }} {{ this.previousYear.year }}</th>
                <th class="td-right">{{ this.valuebookings }} {{ this.thisYear.year }}</th>
                <th v-if="!xs"></th>            
                <th class="td-right" v-if="xl">Revenue/hr {{ this.previousYear.year }} </th>
                <th class="td-right" v-if="xl">Revenue/hr {{ this.thisYear.year }}</th>
            </tr>               

            <!-- row 1 - performance partners -->

            <tr> 
                <td :colspan="lg?2:1">Revenue partners</td>

                <!-- turnover YTD partners - empty for now -->
                <td class="td-right" v-if="!xs">{{ this.previousYear.total_turnover_partner }}</td>
                <td class="td-right" v-if="!xs">{{ this.thisYear.total_turnover_partner }}</td>
                <td class="td-right" v-if="!xs"></td>

                <td class="td-right">
                    <div v-if="result.revenue_partners_result < 0" :class="{'error-markup-fill-line': true, 'padding': !xs}">{{ this.result.revenue_partners_result }}%</div>
                    <div v-else :class="{'correct-markup-fill-line': true, 'padding': !xs}" >+{{ this.result.revenue_partners_result }}%</div>                    
                </td>       

                <!-- partner bookings -->
                <td class="td-right" v-if="!xs">{{ this.previousYear.total_bookings_partner }}</td> 
                <td class="td-right" v-if="!xs">{{ this.thisYear.total_bookings_partner }}</td>
                <td class="td-right"></td>       
                
                <!-- partner avg value per booking -->
                <td class="td-right" v-if="!xs">{{ this.previousYear.avg_value_per_booking_partner }}</td> 
                <td class="td-right" v-if="!xs">{{ this.thisYear.avg_value_per_booking_partner }}</td>
                <td class="td-right">
                    <div v-if="result.partner_value_pc_result < 0" :class="{'error-markup-fill-line': true, 'padding': !xs}">{{ this.result.partner_value_pc_result }}%</div>
                    <div v-else :class="{'correct-markup-fill-line': true, 'padding': !xs}" >+{{ this.result.partner_value_pc_result }}%</div>                    
                </td>       
                
                <td class="td-right" v-if="xl">{{ this.previousYear.avg_turnover_per_hour_partner }}</td>  
                <td class="td-right" v-if="xl">{{ this.thisYear.avg_turnover_per_hour_partner }}</td>

            </tr>

            <!-- row 2 - performance direct -->

            <tr>
                <td :colspan="lg?2:1">Revenue direct</td>

                <!-- turnover YTD direct - empty for now -->
                <td class="td-right" v-if="!xs">{{ this.previousYear.total_turnover_direct }}</td>
                <td class="td-right" v-if="!xs">{{ this.thisYear.total_turnover_direct }}</td>
                <td class="td-right" v-if="!xs"></td>

                <td class="td-right">
                    <div v-if="result.revenue_direct_result < 0" :class="{'error-markup-fill-line': true, 'padding': !xs}">{{ this.result.revenue_direct_result }}%</div>
                    <div v-else :class="{'correct-markup-fill-line': true, 'padding': !xs}" >+{{ this.result.revenue_direct_result }}%</div>                    
                </td>                     


                <!-- per booking direct -->
                <td class="td-right" v-if="!xs">{{ this.previousYear.total_bookings_direct }}</td>                 
                <td class="td-right" v-if="!xs">{{ this.thisYear.total_bookings_direct }}</td>
                <td class="td-right"></td>     
                
                <!-- value per booking direct -->
                <td class="td-right" v-if="!xs">{{ this.previousYear.avg_value_per_booking_direct }}</td> 
                <td class="td-right" v-if="!xs">{{ this.thisYear.avg_value_per_booking_direct }}</td>
                <td class="td-right">
                    <div v-if="result.direct_value_pc_result < 0" :class="{'error-markup-fill-line': true, 'padding': !xs}">{{ this.result.direct_value_pc_result }}%</div>
                    <div v-else :class="{'correct-markup-fill-line': true, 'padding': !xs}" >+{{ this.result.direct_value_pc_result }}%</div>                    
                </td>     

                <td class="td-right" v-if="xl">{{ this.previousYear.avg_turnover_per_hour_direct }}</td>  
                <td class="td-right" v-if="xl">{{ this.thisYear.avg_turnover_per_hour_direct }}</td>
            </tr>

            <!-- row 3 totals -->

            <tr class="tr-bottom-top">
                <td :colspan="lg?2:1">Totals</td>
                        
                
                <!-- turnover YTD totals -->
                <td class="td-right" v-if="!xs">{{ this.previousYear.total_turnover }}</td>
                <td class="td-right" v-if="!xs">{{ this.thisYear.total_turnover }}</td>
                <td class="td-right" v-if="!xs"></td>

                <td class="td-right">
                    <div v-if="result.revenue_total_result < 0" :class="{'error-markup-fill-line': true, 'padding': !xs}">{{ this.result.revenue_total_result }}%</div>
                    <div v-else :class="{'correct-markup-fill-line': true, 'padding': !xs}" >+{{ this.result.revenue_total_result }}%</div>                    
                </td>                        
                
                <!-- number of bookings total -->
                <td class="td-right" v-if="!xs">{{ this.previousYear.total_bookings }}</td> 
                <td class="td-right" v-if="!xs">{{ this.thisYear.total_bookings }}</td>
                <td class="td-right"></td>

                <!-- value per booking total -->
                <td class="td-right" v-if="!xs">{{ this.previousYear.avg_value_per_booking }}</td>  
                <td class="td-right" v-if="!xs">{{ this.thisYear.avg_value_per_booking }}</td>              
                <td class="td-right">
                    <div v-if="result.total_value_pc_result < 0" :class="{'error-markup-fill-line': true, 'padding': !xs}">{{ this.result.total_value_pc_result }}%</div>
                    <div v-else :class="{'correct-markup-fill-line': true, 'padding': !xs}" >+{{ this.result.total_value_pc_result }}%</div>                    
                </td>

                <td class="td-right" v-if="xl">{{ this.previousYear.avg_turnover_per_hour }}</td>                  
                <td class="td-right" v-if="xl">{{ this.thisYear.avg_turnover_per_hour }}</td>
                
            </tr>
        </table>
        <div v-else>
            <table>
                <tr>
                    <td>Nothing to display</td>
                </tr>
            </table>
        </div>
    </div>
</template>
<script>
    export default {     
        data () {
                return {
                    result: {},
                    thisYear: {},
                    previousYear: {},
                }
            },    
        computed: {
            xs: function(){
                return this.$vuetify.breakpoint.name === 'xs';
            },
            lg: function(){
                return this.$vuetify.breakpoint.name === 'lg';
            }, 
            xl: function(){
                return this.$vuetify.breakpoint.name === 'xl';
            },
            title: function(){
                return 'Performance YTD';
            },      
            bookings: function(){
                return this.xs?'Nr.B':'Bookings';
            },  
            valuebookings: function(){
                return this.xs?'Val/B':'Value/bkg';
            }              
        },                     
        methods: {                     
            loadPerformance(thisYear, previousYear){
                this.thisYear = thisYear;
                if(previousYear!==null){
                    this.previousYear = previousYear;
                }
                let el;
                try{
                    el = new Object();
                    el["revenue_partners_result"] = (thisYear.total_turnover_partner_nr / (this.previousYear.total_turnover_partner_nr / 100) - 100).toFixed(2);            
                    el["revenue_direct_result"] = (thisYear.total_turnover_direct_nr / (this.previousYear.total_turnover_direct_nr / 100) - 100).toFixed(2);
                    el["revenue_total_result"] = (thisYear.total_turnover_nr / (this.previousYear.total_turnover_nr / 100) - 100).toFixed(2);
                    el["partner_bookings_result"] = (thisYear.total_bookings_partner / (this.previousYear.total_bookings_partner / 100) - 100).toFixed(2);
                    el["direct_bookings_result"] = (thisYear.total_bookings_direct / (this.previousYear.total_bookings_direct / 100) - 100).toFixed(2);
                    el["total_bookings_result"] = (thisYear.total_bookings / (this.previousYear.total_bookings / 100) - 100).toFixed(2);
                    el["partner_value_pc_result"] = (thisYear.avg_value_per_booking_partner_nr / (this.previousYear.avg_value_per_booking_partner_nr / 100) - 100).toFixed(2);
                    el["direct_value_pc_result"] = (thisYear.avg_value_per_booking_direct_nr / (this.previousYear.avg_value_per_booking_direct_nr / 100) - 100).toFixed(2);
                    el["total_value_pc_result"] = (thisYear.avg_value_per_booking_nr / (this.previousYear.avg_value_per_booking_nr / 100) - 100).toFixed(2);                  
                    el["partner_value_hour_result"] = ((thisYear.avg_turnover_per_hour_partner_nr / (this.previousYear.avg_turnover_per_hour_partner_nr / 100)) - 100).toFixed(2);    
                    el["direct_value_hour_result"] = ((thisYear.avg_turnover_per_hour_direct_nr / (this.previousYear.avg_turnover_per_hour_direct_nr / 100)) - 100).toFixed(2);    
                    el["total_value_hour_result"] =  ((thisYear.avg_turnover_per_hour_nr / (this.previousYear.avg_turnover_per_hour_nr / 100)) - 100).toFixed(2);                                  
                    this.result = el;
                } catch(err){
                    this.result = {}; // return empty object -> table will not be rendered
                }
            },
        }
    }
</script>
<style scoped>
    .table-font{
        font-size:12px !important;
    }
    .td-right{
        text-align: end;        
    }
    .td-left{
        text-align:start;
    }    
    .td-left.bold{
        font-weight: 800 !important;
    }    
    .tr-bottom-border{
        border: 1px solid lightblue;
        border-collapse: collapse;
        border-top: hidden;
        border-left: hidden;
        border-right: hidden;    

    }
    .tr-bottom-top{
        border: 1px solid lightblue;
        border-collapse: collapse;
        border-bottom: hidden;
        border-left: hidden;
        border-right: hidden;    

    }    
    table,
    th,
    td {
        font-weight: 400 !important;
        border-collapse: collapse;
        padding-left: 15px;
        padding-top: 2px;
        padding-bottom: 2px;
        text-align:left;
    }   
    .correct-markup-fill-line{
        font-weight: 500;
        text-align: end;        
        background-color: transparent !important;
        color: rgb(36, 154, 36) !important;
    }      
    .padding{
        padding-right: 10px;
    }               
    .error-markup-fill-line{
        font-weight: 500;
        text-align: end;
        background-color: transparent !important;
        color:red !important;
    }     
</style>